import { useMemo } from "react"

import { FilterRendererContext } from "../contexts/FilterRendererContext/context"
import type { FilterRendererSize, FilterRendererVariant } from "../contexts/FilterRendererContext/typings"
import { FilterManager } from "../manager"

interface FilterRendererProps<TData> {
	filterManager: FilterManager<TData>
	size?: FilterRendererSize
	variant?: FilterRendererVariant
}

export const FilterRenderer = <TData,>(props: FilterRendererProps<TData>) => {
	const { filterManager, size = "md", variant = "fill" } = props

	const contextValue = useMemo(
		() => ({
			size,
			variant,
		}),
		[size, variant],
	)

	return (
		<FilterRendererContext value={contextValue}>
			{filterManager.getFilters().length > 0 && (
				<div className="flex h-max w-full flex-wrap gap-2">
					{filterManager.getFilters().map((filter) => {
						return filter.render(filterManager)
					})}
				</div>
			)}
		</FilterRendererContext>
	)
}
